<template>
  <div class="table-container">
    <!-- New discount rules engine table -->
    <table v-if="useDiscountRulesEngine" cellspacing="0" class="table-element">
      <thead>
        <tr class="header">
          <th class="cell"></th>
          <th class="cell">Type</th>
          <th class="cell">Rule Name</th>
          <th class="cell">Discount Total</th>
          <th class="cell">Items Affected</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row" v-for="discount of sortedDiscounts" :key="discount.ruleId">
          <td class="cell">
            <BaseBtn
              @click="removeDiscount(discount.ruleId)"
              label="Remove"
              :colorType="1"
              :disabled="discount.discountType == 'customer' || discount.discountType == 'bundle' || discount.discountType == 'salePricing' || isModifyingDiscount"
              :isLoading="isModifyingDiscount"
            />
          </td>
          <td class="cell discount-name">{{ discount.discountType }}</td>
          <td class="cell">{{ discount.ruleName }}</td>
          <td class="cell">
            {{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(discount.totalDiscount / 100)
            }}
          </td>
          <td class="cell">{{ discount.itemsAffected || discount.itemsDiscounted || 0 }}</td>
        </tr>
      </tbody>
    </table>
    <!-- Legacy table -->
    <table v-else cellspacing="0" class="table-element">
      <thead>
        <tr class="header">
          <th class="cell"></th>
          <th class="cell">Type</th>
          <th class="cell">Discount Total</th>
          <th class="cell">Coupon Code</th>
          <th class="cell">Coupon Amount</th>
          <th class="cell">Coupon Percent</th>
          <th class="cell">Instant Amount</th>
          <th class="cell">Instant Percent</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row" v-for="discount of discounts" :key="discount._id">
          <td class="cell">
            <BaseBtn
              @click="removeDiscount(discount._id)"
              label="Cancel"
              :colorType="1"
              :disabled="discount.type == 'customer' || discount.type == 'bundle-pricing'"
            />
          </td>
          <td class="cell discount-name">{{ discount.type }}</td>
          <td class="cell">
            {{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(discount.amountDiscountedInDollars)
            }}
          </td>
          <td class="cell">{{ discount.couponName }}</td>
          <td class="cell">{{ couponAmount(discount) }}</td>
          <td class="cell">{{ couponPercent(discount) }}</td>
          <td class="cell">{{ instantDiscountAmount(discount) }}</td>
          <td class="cell">{{ instantDiscountPercent(discount) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="list__noDiscounts" v-if="discounts.length == 0">
      No discounts applied
    </div>
  </div>
</template>

<script>
import BaseBtn from "@/components/Base/Button/Button.vue";
import Utilities from "@/lib/Utilities";

export default {
  data() {
    return {};
  },
  components: {
    BaseBtn,
  },
  props: {
    discounts: {
      type: Array,
      default: () => [],
    },
    useDiscountRulesEngine: {
      type: Boolean,
      default: false,
    },
    isModifyingDiscount: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sortedDiscounts() {
      if (!this.discounts || this.discounts.length === 0) {
        return [];
      }

      // Create a copy to avoid mutating the original array
      const sorted = [...this.discounts];

      // Sort: salePricing goes to bottom, everything else maintains original order
      return sorted.sort((a, b) => {
        const aIsSalePricing = a.discountType === 'salePricing'
        const bIsSalePricing = b.discountType === 'salePricing'

        // If both are salePricing or both are not, maintain original order
        if (aIsSalePricing === bIsSalePricing) {
          return 0;
        }

        // salePricing goes to bottom (return 1 means a comes after b)
        return aIsSalePricing ? 1 : -1;
      });
    },
  },
  methods: {
    removeDiscount(discountId) {
      this.$emit("removeDiscount", discountId);
    },
    couponAmount(discount) {
      if (discount.type != "coupon" && discount.type != 'alpine-discount') return null;

      if (discount.couponDiscountType == "$") {
        return Utilities.formatPrice(discount.couponAmount);
      }
      return null;
    },
    couponPercent(discount) {
      if (discount.type != "coupon" && discount.type != 'alpine-discount') return null;

      if (discount.couponDiscountType == "%") {
        return `${discount.couponAmount}%`;
      }
      return null;
    },
    instantDiscountAmount(discount) {
      if (discount.type != "instant") return null;

      if (discount.instantDiscountType == "$") {
        return Utilities.formatPrice(discount.instantDiscountAmount);
      }
      return null;
    },
    instantDiscountPercent(discount) {
      if (discount.type != "instant") return null;

      if (discount.instantDiscountType == "%") {
        return `${discount.instantDiscountAmount}%`;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_list.scss";
</style>
